import { useState, useEffect } from 'react';

interface UserInfo {
  name: string;
  country: string;
}

/**
 * Custom hook to get user information from localStorage
 * @returns User information (name and country)
 */
export const useUserInfo = (): UserInfo => {
  const [userInfo, setUserInfo] = useState<UserInfo>({
    name: '',
    country: ''
  });

  useEffect(() => {
    // Get user info from localStorage
    const name = localStorage.getItem('name') || '';
    const country = localStorage.getItem('country') || '';
    
    setUserInfo({ name, country });
  }, []);

  return userInfo;
};

export default useUserInfo;
